var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bsalert"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bsAlert.dismissCountDown),expression:"bsAlert.dismissCountDown"}],class:"alert alert-" + _vm.bsAlert.type},[_c('span',[_vm._v(_vm._s(_vm.bsAlert.msg))]),_c('button',{staticClass:"btn-close",attrs:{"type":"button"},on:{"click":_vm.countDownChanged}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }